/// <amd-module name="Agile/Backlogs/Directory/BacklogDirectory" />
import { AreaName, LOAD_DIRECTORY } from "Agile/Backlogs/Directory/BacklogDirectoryConstants";
import { artifactName } from "Agile/Backlogs/Directory/Resources";
import { ConnectedDirectoryContentView } from "Agile/Directory/Components/DirectoryContentView";
import { IDirectoryArtifact, IDirectoryViewState } from "Agile/Directory/DirectoryContracts";
import { IDirectorySagaContext, getDirectoryProviderProps } from "Agile/Directory/Redux/getDirectoryProviderProps";
import * as React from "react";
import { IRootProviderProps, RootProvider } from "VSS/Redux/Deprecated/RootProvider";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export class BacklogDirectory extends VssComponent {
    private _hubViewState: VssHubViewState;
    private _rootProviderProps: IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<IDirectoryArtifact>>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);
        this._hubViewState = new VssHubViewState(context.pageContext);
        this._rootProviderProps = getDirectoryProviderProps(
            {
                myDataProviderId: "ms.vss-work-web.backlogs-hub-directory-data-provider",
                allDataProviderId: "ms.vss-work-web.backlogs-hub-all-directory-data-provider",
                hubName: AreaName
            },
            this._hubViewState,
            context.pageContext,
            AreaName
        );
    }

    public render(): JSX.Element {
        return (
            <RootProvider {...this._rootProviderProps}>
                <ConnectedDirectoryContentView
                    artifactName={artifactName}
                    artifactIcon={{ iconName: "BacklogList" }}
                    hubViewState={this._hubViewState}
                    ttiScenarioProps={{
                        areaName: AreaName,
                        featureName: LOAD_DIRECTORY
                    }}
                />
            </RootProvider>
        );
    }
}

VssComponent.register("backlogDirectory", BacklogDirectory);
